<script lang="ts" setup>
/**
 * UI-kit component
 * Category: Scope
 * Name: GateScope
 */
import type { ScopeGateArea } from '@shared/lib/scope'

import { useGateScope } from './use-gate-scope.hook'

defineOptions({
  name: 'GateScope',
})

const props = withDefaults(defineProps<{
  area?: ScopeGateArea
}>(), {
  area: 'page',
})

const { isSkeletonShown, skeletonComponent } = useGateScope({ area: props.area })
</script>

<template>
  <div
    v-if="isSkeletonShown"
    class="gate-scope"
  >
    <component :is="skeletonComponent" />
  </div>
  <slot v-else />
</template>

<style scoped lang="scss" src="./GateScope.scss" />
